import React, { useState } from "react"
import { InputTypeText, InputTypeArea } from '../../elements'
import { Form } from 'informed'
import { createSQLReportData } from "../../services/reports_services"
import { Redirect } from 'react-router'
const SQLReportFormPage = () => {
    const [formValues, setFormValues] = useState( null )
    const sendForm = () => {
        createSQLReportData( formValues ).then( () => {
            window.location.href = "/reports/sql"

        } )
    }

    return (
        <div className="p-3 d-flex flex-column justify-center align-center">
            <div className="d-flex align-center">
                <h4>Criar Relatório SQL</h4>
            </div>
            <div style={gridStyle}>
                <Form className="w-100" onValueChange={v => setFormValues( v )}>
                    <InputTypeText col="12" field="name" label="Nome do Relatório" />
                    <InputTypeArea style={{ minHeight: '80px', }} field="sql" label="SQL" col="12" />
                    <div className="text-right">
                        <div className="col-md-3 p-0 offset-md-9 col-sm-12">
                            <button
                                className="btn btn-primary"
                                type="submit"
                                onClick={() => sendForm()}
                            >
                                Salvar
                            </button>
                        </div>
                    </div>
                </Form>
            </div>
        </div>
    )
}

export default SQLReportFormPage

const gridStyle = {
    display: "flex",
    width: "100%",
    gap: "10px",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "10px",
}

const buttonStyle = {
    border: "none",
    width: "50%",
    height: "30px",
    cursor: "pointer",
    color: "#ffff",
    borderRadius: "5px",
    backgroundColor: "#499d96",
    textAlign: "center",
    outline: "none",
}